import { type DataForParent, microFrontListener } from '@b2ag/micro-front-tools'
import { useAnalyticService } from '@b2ag/plugin-aladin-gtm'
import { useRouter } from 'vue-router'
import { PAGE_TYPE, PAGE_ANALYTICS_INFO } from '../page-types'
import { callbacksFromCheckoutMicroFrontIframe } from '@b2ag/checkout'
import { useStore } from 'vuex'

/* ------- MICROFRONT - CHECKOUT ------- */

const orderConfirmationRouteDefinition = {
  path: '/order-confirmation/:checkoutId',
  name: 'checkout-v2-order-confirmation',
  component: () => import('@b2ag/micro-front-checkout-v2/app'),
  props: (route) => ({
    microFrontName: 'checkout-v2',
    viewName: 'order-confirmation',
    checkoutId: route.params.checkoutId,
  }),
  beforeEnter() {
    microFrontListener({
      iframe: { href: window.location.origin },
      router: useRouter() as any,
      analyticService: useAnalyticService(),
    })
  },
  meta: {
    private: true,
    analyticsPageInfo: PAGE_ANALYTICS_INFO.CHECKOUT,
  },
}

export const orderConfirmationRoute = [orderConfirmationRouteDefinition]

export const checkoutRoutes = [
  {
    path: '/purchases/:checkoutId',
    name: 'buy-layout-agri',
    component: () => import('@b2ag/micro-front-checkout/app'),
    props: (route) => {
      return {
        microFrontName: 'checkout',
        viewName: `buy-layout-agri`,
        checkoutId: route.params.checkoutId,
      }
    },
    beforeEnter() {
      const store = useStore()
      microFrontListener({
        iframe: { href: window.location.origin },
        router: useRouter() as any,
        analyticService: useAnalyticService(),
        callbackForMessages: (data: DataForParent) => callbacksFromCheckoutMicroFrontIframe(data, store),
      })
    },
    meta: {
      private: true,
      analyticsPageType: PAGE_TYPE.PURCHASES,
      layout: 'empty',
    },
  },
  {
    path: '/shopping-list/:shoppingListId/order/:checkoutId',
    name: 'buy-layout-tech',
    component: () => import('@b2ag/micro-front-checkout/app'),
    props: (route) => {
      return {
        microFrontName: 'checkout',
        viewName: 'buy-layout-tech',
        checkoutId: route.params.checkoutId,
        shoppingListId: route.params.shoppingListId,
      }
    },
    beforeEnter() {
      microFrontListener({
        iframe: { href: window.location.origin },
        router: useRouter() as any,
        analyticService: useAnalyticService(),
      })
    },
    meta: {
      private: true,
      analyticsPageInfo: PAGE_ANALYTICS_INFO.CHECKOUT,
      layout: 'empty',
    },
  },
  {
    path: '/checkout/:checkoutId',
    name: 'checkout-v2',
    component: () => import('@b2ag/micro-front-checkout-v2/app'),
    props: (route) => ({
      microFrontName: 'checkout-v2',
      viewName: 'checkout',
      checkoutId: route.params.checkoutId,
    }),
    beforeEnter() {
      microFrontListener({
        iframe: { href: window.location.origin },
        router: useRouter() as any,
        analyticService: useAnalyticService(),
      })
    },
    meta: {
      private: true,
      analyticsPageInfo: PAGE_ANALYTICS_INFO.CHECKOUT,
      layout: 'default',
    },
  },
]
